import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { DeleteUserMutation, User, UserInput } from '#/graphql/types';
import { deleteUser } from '#/graphql/mutations';
import { get, omit, pick } from 'lodash';

const q = gql(deleteUser);

const useUserDelete = () => {
  const [mutation, result] = useMutation<DeleteUserMutation>(q);
  const deleteUser = useCallback(
    async (itemId: string) => {
      const response = await mutation({
        variables: {
          id: itemId,
        },
      });

      return get(response, 'data.deleteUser', undefined);
    },
    [mutation],
  );

  return { deleteUser, result };
};
// Used in the modules ModuleDataGrid file
export default useUserDelete;
